import { z } from "zod";
export const problemSchema = z.object({
    type: z.string().url().optional(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    code: z.string().optional(),
});
//# sourceMappingURL=error.js.map